import { render } from "./ArrowButton.vue?vue&type=template&id=4cc1ddc8"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__